var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBussines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#C8E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4775 12.9323L26.37 21.3638C26.2027 22.0328 25.6042 22.5 24.9142 22.5H11.9175C11.1562 22.5 10.5157 21.93 10.428 21.174L8.90925 9H7.875C7.25325 9 6.75 8.49675 6.75 7.875C6.75 7.25325 7.25325 6.75 7.875 6.75H9.89025C10.4527 6.75 10.9282 7.1655 11.0047 7.722L11.5912 12H27.75C28.2375 12 28.596 12.459 28.4775 12.9323Z",
    fill: "#1062D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 26.25C11.25 27.4905 12.2595 28.5 13.5 28.5C14.7405 28.5 15.75 27.4905 15.75 26.25C15.75 25.0095 14.7405 24 13.5 24C12.2595 24 11.25 25.0095 11.25 26.25Z",
    fill: "#1062D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 26.25C24.75 25.0095 23.7405 24 22.5 24C21.2595 24 20.25 25.0095 20.25 26.25C20.25 27.4905 21.2595 28.5 22.5 28.5C23.7405 28.5 24.75 27.4905 24.75 26.25Z",
    fill: "#1062D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBussines);
export default __webpack_public_path__ + "static/media/cartBussines.776e8e5314199a2b401e56f806acac67.svg";
export { ForwardRef as ReactComponent };